import {lazy} from "react";

export const AdminAccountsTableLazy = lazy(() => import('./AdminAccountsTable'))
